import React from 'react';
import {
  type PublicAnnouncement,
  getActiveAnnouncements
} from '~/common/api-client';
import useAPI, { type State as BaseState } from '~/common/hooks/useAPI';

interface State extends Omit<BaseState<PublicAnnouncement[]>, 'data'> {
  announcements: PublicAnnouncement[];
}

/**
 * Fetch the currently-active announcements for a product from the public endpoint.
 */
const useActiveAnnouncements = (productSlug: string): State => {
  const dataLoader = React.useCallback(
    () => getActiveAnnouncements(productSlug),
    [productSlug]
  );
  const state = useAPI(dataLoader);
  return {
    error: state.error,
    loading: state.loading,
    announcements: state.data || []
  };
};

export default useActiveAnnouncements;
